export const convertStringCamelCaseToSnakeCase = (str: string): string => {
  // If string starts with uppercase, don't convert it
  if (/^[A-Z]/.test(str)) {
    return str;
  }
  
  // Convert camelCase to snake_case (lowercase)
  return str.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
};


/**
 * Converts a camelCase string to a snake_case string
 * 
 * @example
 * convertCamelCaseToSnakeCase('camelCaseString') // 'camel_case_string'
 * convertCamelCaseToSnakeCase('CamelCaseString') // 'CamelCaseString'
 * convertCamelCaseToSnakeCase('camelCaseStringWithNumbers123') // 'camel_case_string_with_numbers_123'
 * convertCamelCaseToSnakeCase('B') // 'B'
 * convertCamelCaseToSnakeCase('camelCaseStringWithSpecialChars!@#$%^&*()') // 'camel_case_string_with_special_chars_!@#$%^&*()'
 * 
 * @param input - The input object to convert to snake_case
 * @returns The input object with camelCase keys converted to snake_case
 */
const convertCamelCaseToSnakeCase = (input: any): any => {
  // Handle null, undefined, and primitive values
  if (input === null || input === undefined) {
    return input;
  }

  // Handle primitive types (string, number, boolean)
  if (typeof input !== 'object') {
    return input;
  }

  // Handle Date objects and other built-in objects that shouldn't be converted
  if (input instanceof Date || input instanceof RegExp || input instanceof Error) {
    return input;
  }

  // Handle arrays - recursively process each item
  if (Array.isArray(input)) {
    return input.map(item => convertCamelCaseToSnakeCase(item));
  }

  // Handle plain objects - convert keys and recursively process values
  if (input.constructor === Object || input.constructor === undefined) {
    const newObject: any = {};
    
    Object.keys(input).forEach((key) => {
      const snakeKey = convertStringCamelCaseToSnakeCase(key);
      newObject[snakeKey] = convertCamelCaseToSnakeCase(input[key]);
    });
    
    return newObject;
  }

  // For other object types (class instances, etc.), return as-is
  return input;
};

export default convertCamelCaseToSnakeCase;